import React from "react";
import EnterOfSettlementsBalancesGenericSkeleton from "./EnterOfSettlementsBalancesGenericSkeleton";

function EnterOfSettlementsBalancesDetailSkeleton() {
  return (
    <>
      <EnterOfSettlementsBalancesGenericSkeleton />
    </>
  );
}

export default EnterOfSettlementsBalancesDetailSkeleton;
